interface EpisodeListProps {
  total: number;
  current: number;
  onSelect: (index: number) => void;
  title: string;
}

export default function EpisodeList({ total, current, onSelect, title }: EpisodeListProps) {
  const episodes = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <div className="rounded-lg bg-background-100/70 border border-background-200 p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-lg font-bold text-foreground-950">
          {title} · 选集
        </h2>
        <span className="text-xs text-foreground-500">共 {total} 集</span>
      </div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1 md:flex-wrap md:overflow-x-visible md:max-h-60 md:overflow-y-auto">
        {episodes.map((ep) => {
          const active = ep === current;
          return (
            <button
              key={ep}
              type="button"
              onClick={() => onSelect(ep)}
              className={`shrink-0 px-3.5 py-2 rounded-md text-sm cursor-pointer whitespace-nowrap transition-colors ${
                active
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "bg-background-50 text-foreground-700 border border-background-200 hover:text-primary-600 hover:border-primary-300"
              }`}
            >
              第{ep}集
            </button>
          );
        })}
      </div>
    </div>
  );
}